module.exports = __webpack_public_path__ + "static/media/event-screenshot-bts-army.29955ad6.png";